module.exports = __webpack_public_path__ + "static/media/RD_Sviadnov1.e6e191ca.jpg";